const getCheckboxLabel = (consentCheckboxes, subscriptionId) => consentCheckboxes[subscriptionId].content;
export default getCheckboxLabel;